import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const navLinks = [
  { label: "Undervisning", to: "/undervisning" },
  { label: "Coaching", to: "/coaching" },
  { label: "Om mig", to: "/om" },
  { label: "Referencer", to: "/referencer" },
  { label: "Perspektiver", to: "/perspektiver" },
];

export const PreviewNavbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav
      className="fixed top-0 inset-x-0 z-50 bg-white/70 backdrop-blur-xl border-b border-black/5"
      data-testid="preview-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link
            to="/"
            onClick={() => setOpen(false)}
            className="font-display text-2xl font-semibold text-[#111827] tracking-tight"
            data-testid="preview-navbar-brand"
          >
            Stine Eskesen
          </Link>

          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `text-[14px] transition-colors duration-200 ${
                    isActive
                      ? "font-semibold text-[#852936]"
                      : "text-[#111827]/60 hover:text-[#111827]"
                  }`
                }
                data-testid={`preview-nav-link-${link.to.slice(1)}`}
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden lg:block">
            <Link
              to="/kontakt"
              className="inline-flex items-center rounded-full bg-[#852936] px-5 py-2.5 text-[14px] font-medium text-white transition-transform duration-300 hover:scale-[1.04] preview-shadow-soft"
              data-testid="preview-nav-kontakt-cta"
            >
              Nysgerrig?
            </Link>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-[#111827]/70 hover:text-[#111827] transition-colors"
            data-testid="preview-mobile-menu-button"
            aria-label="Menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2" data-testid="preview-mobile-menu">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `text-[15px] transition-colors ${
                      isActive ? "font-semibold text-[#852936]" : "text-[#111827]/70 hover:text-[#111827]"
                    }`
                  }
                  data-testid={`preview-mobile-nav-link-${link.to.slice(1)}`}
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/kontakt"
                onClick={() => setOpen(false)}
                className="inline-flex w-fit items-center rounded-full bg-[#852936] px-6 py-2.5 text-[15px] font-medium text-white"
                data-testid="preview-mobile-nav-kontakt"
              >
                Nysgerrig?
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default PreviewNavbar;
